import React, { createRef, useRef, useState } from "react";
import { FormCard } from "./components/form-card";
import { stepStyle } from "./step.css";
import { uid } from "uid/single";
import { Select } from "./components/select";
import { Space } from "./components/space";
import { Label } from "./components/label";
import { Button } from "./components/button";
import {
  primaryButton,
  secondaryButton,
  inputVariants,
  btnAdicionarRemoverStyle,
} from "./components/button.css";
import { formButtonsWrapper } from "./index.css";
import { Checkbox } from "./components/checkbox";
import { Input } from "./components/input";

import { renderSelectOptions } from "./render-select-options";
import { TextEditor } from "./components/text-editor";
import { IconPlusCircle } from "./icons/icon-plus-circle";
import { IconMinusCircle } from "./icons/icon-minus-circle";
import {
  wrapperAdicionarRemoverFichas,
  selectFichasStyle,
  restringirEmailsIndicacaoStyle,
  outrosParceirosStyle,
  parceiroStyle,
  parceirosListStyle,
  containerInfoParceiro,
  containerDescriptionParceiro,
} from "./step-2.css";
import { Text } from "@vagastec/ensemble-core";
import { useLocation } from "react-router-dom";
import { vars } from "./theme.css";
import { validateEmailWithOptionalUsername } from "./validate-email";
import { wrapperTooltipStyle } from "./components/tooltip.css";
import { Tooltip } from "./components/tooltip";
import CreatableSelect from "react-select/creatable";
import { RadioButton } from "./components/radio-button";
import { Fieldset } from "./components/fieldset";
import { Spinner } from "./components/spinner";
import { Toaster, useToaster } from "@vagastec/ensemble-core";
import { getCookie } from "./cookies";
import { extractTextFromHtmlString } from "./extract-text-from-html-string";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import SelectLoader from "./components/select-loader";
import { Multi } from "./components/multi";
import { separatorStyle } from "./step-4.css";
import { Steps } from "./steps";
import {
  button,
  buttonVariant,
  circle,
  circleVariant,
  divider,
  dividerVariant,
} from "./steps.css";

export function Step2({ formState, setFormState, setSelectedStepId }) {
  const [hasTriedToSubmit, setHasTriedToSubmit] = React.useState(false);
  const [active, setActive] = React.useState(false);
  const [isPostPending, setIsPostPending] = React.useState(false);
  const [toasts, addToast, removeToast] = useToaster();
  const intl = useIntl();

  React.useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const location = useLocation();
  const isVagaModelo = location.pathname === "/nova-vaga-modelo";
  //  || location.pathname?.includes("/editar-vaga-modelo");

  const emailMensagemTextLength = extractTextFromHtmlString(
    formState.emailMensagem
  ).length;

  function renderFichasSelectOptions(selectedOptionId) {
    if (formState.fichasError)
      return (
        <option>
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.ocorreuErro",
              defaultMessage: "Ocorreu um erro",
            })
          )}
        </option>
      );
    if (!formState.fichasData)
      return (
        <option value="">
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "info.carregando",
              defaultMessage: "Carregando...",
            })
          )}
        </option>
      );
    return (
      <>
        <option value="">
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "info.selecioneOpcao",
              defaultMessage: "Selecione uma opção...",
            })
          )}
        </option>
        {formState.fichasData
          .filter(
            (v) =>
              v.id === selectedOptionId ||
              !formState.fichasSelected
                .map((currentSelect) => currentSelect.fichaSelecionadaId)
                .includes(v.id)
          )
          .map((v) => (
            <option key={v.id} value={v.id}>
              {v.label}
            </option>
          ))}
      </>
    );
  }

  function renderParceiros() {
    if (formState.parceirosError || formState.creditosEtalentError)
      return (
        <option>
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.ocorreuErro",
              defaultMessage: "Ocorreu um erro",
            })
          )}
        </option>
      );
    if (!formState.parceirosData || !formState.creditosEtalentData)
      return (
        <option>
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.loading",
              defaultMessage: "Carregando",
            })
          )}
        </option>
      );
    const creditos = formState.creditosEtalentData[0]["creditos_etalent"];

    return (
      <>
        <Label
          text={
            <FormattedMessage
              id="step2.etalent"
              defaultMessage="VAGAS ETALENT - Análise DISC"
            />
          }
        />
        <div className={wrapperTooltipStyle}>
          <Checkbox
            label={
              <FormattedMessage
                id="step2.solicitarEtalent"
                defaultMessage="Solicitar o preenchimento aos profissionais na inscrição"
              />
            }
            disabled={creditos === 0}
            checked={formState.isParceiroEtalentSelecionado}
            onChange={(e) =>
              setFormState({ isParceiroEtalentSelecionado: e.target.checked })
            }
            data-testid="checkbox-etalent"
          />

          {creditos === 0 ? (
            <>
              <Tooltip
                active={active}
                setActive={setActive}
                text={
                  <FormattedMessage
                    id="step2.tooltipEtalent"
                    defaultMessage="Você não possui créditos. Consulte a nossa equipe Comercial"
                  />
                }
              />
            </>
          ) : null}
        </div>
      </>
    );
  }

  function renderEmailsIndicacao() {
    if (formState.emailsIndicacaoError)
      return (
        <option>
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.ocorreuErro",
              defaultMessage: "Ocorreu um erro",
            })
          )}
        </option>
      );
    if (!formState.emailsIndicacaoData)
      return (
        <option value="">
          {intl.formatMessage(
            defineMessage({
              id: "info.carregando",
              defaultMessage: "Carregando...",
            })
          )}
        </option>
      );

    return (
      <div className={restringirEmailsIndicacaoStyle}>
        <Space height=".5rem" />
        <Text as="p" size="rg" weight={600}>
          <FormattedMessage
            id="step2.titleRestringirEmails"
            defaultMessage="Restringir e-mails"
          />
        </Text>
        <Text as="p" size="rg">
          <FormattedMessage
            id="step2.descriptionRestringirEmails"
            defaultMessage="Insira abaixo a lista de e-mails ou domínios de e-mails que poderão
            indicar profissionais para a vaga. Exemplo: joão@empresa.com ou
            @empresa.com. Pressione Enter ou Tab para formar tags."
          />
        </Text>
        <Label
          title={
            <FormattedMessage
              id="step2.infoRestringirEmails"
              defaultMessage="Insira e-mails ou domínios separados por enter"
            />
          }
        >
          <CreatableSelect
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: "40px",
                background: "#fff",
                border: `1px solid rgb(200, 200, 200)`,
                borderRadius: "6px",
                width: "100%",
                color: vars.color.foreground,
              }),
            }}
            components={{ DropdownIndicator: null }}
            isClearable
            isMulti
            menuIsOpen={false}
            value={formState.emailsIndicacao}
            inputValue={formState.emailsIndicacaoInput}
            onChange={(v) => setFormState({ emailsIndicacao: v })}
            onInputChange={(v) => setFormState({ emailsIndicacaoInput: v })}
            onKeyDown={(e) => {
              if (["Enter", "Tab"].includes(e.code)) {
                if (!formState.emailsIndicacaoInput) return;
                e.preventDefault();

                if (
                  !validateEmailWithOptionalUsername(
                    formState.emailsIndicacaoInput
                  )
                )
                  return;

                setFormState((prev) => ({
                  emailsIndicacaoInput: "",
                  emailsIndicacao: [
                    ...prev.emailsIndicacao,
                    prev.emailsIndicacaoInput,
                  ],
                }));
              }
            }}
            placeholder=""
            getOptionLabel={(v) => v}
            getOptionValue={(v) => v}
            isRequired
          />
        </Label>
      </div>
    );
  }

  function addEmailIndicacaoPostErrorToast() {
    const title = intl.formatMessage(
      defineMessage({
        id: "mensagem.ocorreuErro",
        defaultMessage: "Ocorreu um erro",
      })
    );

    const body = intl.formatMessage(
      defineMessage({
        id: "step2.bodyErro",
        defaultMessage: "Não foi possível salvar os e-mails.",
      })
    );
    const variant = "error";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  function addPostEmailIndicacaoSuccessToast() {
    const title = intl.formatMessage(
      defineMessage({
        id: "post.titleSucesso",
        defaultMessage: "Sucesso!",
      })
    );

    const body = intl.formatMessage(
      defineMessage({
        id: "step2.postBodySucesso",
        defaultMessage: "Os e-mails foram cadastrados com sucesso.",
      })
    );

    const variant = "success";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  function handleEmailsIndicacaoSubmit() {
    const TOKEN = getCookie(process.env.ACCESS_TOKEN);

    setIsPostPending(true);
    fetch(`${process.env.HESTIA}/emails_indicacao`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TOKEN}`,
      },
      method: "POST",
      body: JSON.stringify({ emails_dominios: formState.emailsIndicacao }),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        addPostEmailIndicacaoSuccessToast();
        return res.json();
      })
      .catch(() => {
        addEmailIndicacaoPostErrorToast();
      })
      .finally(() => {
        setIsPostPending(false);
      });
  }

  return (
    <form
      className={stepStyle}
      onSubmit={(e) => {
        e.preventDefault();
        setSelectedStepId(3);
      }}
    >
      {!formState.responsavelData && !isVagaModelo ? (
        <SelectLoader />
      ) : (
        <>
          {formState.painelData?.funcionario.admin === true && !isVagaModelo ? (
            <>
              <FormCard
                title={
                  <FormattedMessage
                    id="step3.responsavel"
                    defaultMessage="Responsável pela vaga *"
                  />
                }
                idTitle="responsavel-vaga"
              >
                <Select
                  value={formState.responsavelSelectedId}
                  id="responsavel-vaga"
                  onChange={(e) =>
                    setFormState({
                      responsavelSelectedId: Number(e.target.value),
                    })
                  }
                  required
                  shouldValidate={hasTriedToSubmit}
                  errorMessage={
                    <FormattedMessage
                      id="erro.campoObrigatorio"
                      defaultMessage="Campo obrigatório"
                    />
                  }
                  data-testid="select-responsavel"
                  aria-label="responsável"
                >
                  {renderSelectOptions({
                    data: formState.responsavelData,
                    error: formState.responsavelError,
                    labelKey: "nome",
                    errorMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.erro",
                        defaultMessage: "Ocorreu um erro",
                      })
                    ),
                    loadingMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.loading",
                        defaultMessage: "Carregando...",
                      })
                    ),
                    selectOptionMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.escolherOpcao",
                        defaultMessage: "Selecione uma opção...",
                      })
                    ),
                  })}
                </Select>
              </FormCard>
            </>
          ) : null}
        </>
      )}

      {!formState.subdivisoesData && !isVagaModelo ? (
        <SelectLoader />
      ) : (
        <>
          {(!isVagaModelo &&
            formState.subdivisoesData?.length > 1 &&
            formState.painelData?.funcionario.admin === true) ||
          formState.painelData?.funcionario.permissoes.dir_compartilhar_vaga ===
            true ? (
            <>
              <FormCard
                title={
                  <FormattedMessage
                    id="step3.subdivisoes"
                    defaultMessage="Permissão de acesso a outras áreas (subdivisões) da empresa"
                  />
                }
              >
                <Multi
                  name="subdivisoes"
                  options={formState.subdivisoesData?.map((v) => ({
                    ...v,
                    label: `${v.label_divisao} - ${v.label}`,
                  }))}
                  state={formState.subdivisoesSelected}
                  onChange={(v) => {
                    setFormState({ subdivisoesSelected: v });
                  }}
                  getOptionValue={(option) => option.id}
                  noOptionsMessage={() => {
                    return formState.subdivisoesError ? (
                      <FormattedMessage
                        id="mensagem.ocorreuErro"
                        defaultMessage="Ocorreu um erro"
                      />
                    ) : (
                      <FormattedMessage
                        id="step1-limiteOpcoes"
                        defaultMessage="Não há mais opções disponíveis."
                      />
                    );
                  }}
                  placeholder={
                    <Text size="sm" fontColor={vars.color.lightForeground}>
                      <FormattedMessage
                        id="placeholder.pesquiseSelecione"
                        defaultMessage="Pesquise e selecione"
                      />
                    </Text>
                  }
                  data-testid="select-subdivisoes"
                ></Multi>
              </FormCard>
            </>
          ) : null}
        </>
      )}

      <FormCard
        title={
          isVagaModelo ? (
            <FormattedMessage
              id="step1.titleFasesOpcional"
              defaultMessage={"Etapas do processo seletivo"}
            />
          ) : (
            <FormattedMessage
              id="step1.titleFasesObrigatorio"
              defaultMessage={"Etapas do processo seletivo *"}
            />
          )
        }
        description={
          <FormattedMessage
            id="step1.descriptionFases"
            defaultMessage="Selecione uma das fases já cadastradas em <a></a>."
            values={{
              a: (chunks) => (
                <a
                  href="/configuracoes/editar-fases"
                  target="_blank"
                  style={{
                    color: vars.color.brand,
                    textDecoration: "none",
                  }}
                >
                  {chunks}
                  <b>
                    <FormattedMessage
                      id="step2.configuracoes"
                      defaultMessage="Configurações"
                    />
                  </b>
                </a>
              ),
            }}
          />
        }
        data-testid="bloco-fases"
      >
        <Multi
          name="fases"
          options={formState.fasesData}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.nome}
          required={!isVagaModelo}
          state={formState.fasesSelected.sort((a, b) => a.ordem - b.ordem)}
          onChange={(v) => {
            setFormState({ fasesSelected: v });
          }}
          noOptionsMessage={() => {
            return formState.fasesError ? (
              <FormattedMessage
                id="mensagem.ocorreuErro"
                defaultMessage="Ocorreu um erro"
              />
            ) : (
              <FormattedMessage
                id="step1-limiteOpcoes"
                defaultMessage="Não há mais opções disponíveis."
              />
            );
          }}
          placeholder={
            <Text size="sm" fontColor={vars.color.lightForeground}>
              <FormattedMessage
                id="placeholder.selecioneProcessoSeletivo"
                defaultMessage="Selecione as etapas do seu processo seletivo"
              />
            </Text>
          }
          errorMessage={
            <FormattedMessage
              id="erro.campoObrigatorio"
              defaultMessage="Campo obrigatório"
            />
          }
          shouldValidate={hasTriedToSubmit}
        ></Multi>

        <Space height="1rem" />

        <div
          style={{
            display: "flex",
            overflow: "auto",
            overflowWrap: "break-word",
          }}
        >
          {formState.fasesSelected?.map((fase, index) => (
            <React.Fragment key={fase.id}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  maxWidth: "200px",
                  textAlign: "left",
                }}
              >
                <span className={`${circle} ${circleVariant["base"]}`}>
                  {index + 1}
                </span>
                <Text size="sm" as="span">
                  {fase.nome}
                </Text>
              </div>
              {index < formState.fasesSelected.length - 1 ? (
                <div className={`${divider} ${dividerVariant["base"]}`}></div>
              ) : null}
            </React.Fragment>
          ))}
        </div>
      </FormCard>

      <FormCard
        title={
          <FormattedMessage
            id="step2.testesIntegracoes"
            defaultMessage="Avaliações, testes e integrações"
          />
        }
      >
        {renderParceiros()}
        <Space height="1.5rem" />

        {/* <Text as="h3" weight={600}>
          <FormattedMessage
            id="step2.outrosParceiros"
            defaultMessage=" Outros parceiros"
          />
        </Text>
        <Space height=".5rem" />
        <div className={outrosParceirosStyle}>
          <ul className={parceirosListStyle}>
            <li className={parceiroStyle}>
              <a
                href="https://parceiros.vagas.com.br/huddle"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className={containerInfoParceiro}>
                  <img
                    src="/vagas/processos-seletivos/assets/huddle.png"
                    alt="logotipo da Huddle"
                    width="90px"
                    height="70px"
                  ></img>
                  <div className={containerDescriptionParceiro}>
                    <Text as="h4">
                      {" "}
                      <FormattedMessage
                        id="step2.huddle"
                        defaultMessage="Huddle"
                      />{" "}
                    </Text>
                    <Text as="p" fontColor={vars.color.lightForeground}>
                      <FormattedMessage
                        id="step2.descriptionHuddle"
                        defaultMessage="Games online de avaliação comportamental de candidatos."
                      />
                    </Text>
                  </div>
                </div>
              </a>
            </li>
            <li className={parceiroStyle}>
              <a
                href="https://parceiros.vagas.com.br/arbache"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className={containerInfoParceiro}>
                  <img
                    src="/vagas/processos-seletivos/assets/arbache.png"
                    alt="logotipo da Arbache"
                    width="90px"
                    height="70px"
                  ></img>
                  <div className={containerDescriptionParceiro}>
                    <Text as="h4">
                      {" "}
                      <FormattedMessage
                        id="step2.arbache"
                        defaultMessage="Arbache"
                      />
                    </Text>
                    <Text as="p" fontColor={vars.color.lightForeground}>
                      <FormattedMessage
                        id="step2.descriptionArbache"
                        defaultMessage="Diagnósticos e desenvolvimento de competências."
                      />
                    </Text>
                  </div>
                </div>
              </a>
            </li>
            <li className={parceiroStyle}>
              <a
                href="https://parceiros.vagas.com.br/thomas"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className={containerInfoParceiro}>
                  <img
                    src="/vagas/processos-seletivos/assets/thomas.png"
                    alt="logotipo da Thomas"
                    width="90px"
                    height="70px"
                  ></img>

                  <div className={containerDescriptionParceiro}>
                    <Text as="h4">
                      {" "}
                      <FormattedMessage
                        id="step2.thomas"
                        defaultMessage="Thomas"
                      />
                    </Text>
                    <Text as="p" fontColor={vars.color.lightForeground}>
                      <FormattedMessage
                        id="step2.descriptionThomas"
                        defaultMessage="Avaliações psicométricas comportamentais, método DISC."
                      />
                    </Text>
                  </div>
                </div>
              </a>
            </li>
            <li className={parceiroStyle}>
              <a
                href="https://parceiros.vagas.com.br/job-coach"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className={containerInfoParceiro}>
                  <img
                    src="/vagas/processos-seletivos/assets/jobcoach.png"
                    alt="logotipo da Jobcoach"
                    width="90px"
                    height="70px"
                  ></img>

                  <div className={containerDescriptionParceiro}>
                    <Text as="h4">
                      {" "}
                      <FormattedMessage
                        id="step2.jobcoach"
                        defaultMessage="Jobcoach"
                      />{" "}
                    </Text>
                    <Text as="p" fontColor={vars.color.lightForeground}>
                      <FormattedMessage
                        id="step2.descriptionJobcoach"
                        defaultMessage="Avaliação comportamental e de valores pessoais."
                      />
                    </Text>
                  </div>
                </div>
              </a>
            </li>
            <li className={parceiroStyle}>
              <a
                href="https://parceiros.vagas.com.br/dom"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className={containerInfoParceiro}>
                  <img
                    src="/vagas/processos-seletivos/assets/dom.png"
                    alt="logotipo da Dom Diagnósticos"
                    width="90px"
                    height="70px"
                  ></img>
                  <div className={containerDescriptionParceiro}>
                    <Text as="h4">
                      {" "}
                      <FormattedMessage
                        id="step2.dom"
                        defaultMessage="DOM Diagnósticos"
                      />{" "}
                    </Text>
                    <Text as="p" fontColor={vars.color.lightForeground}>
                      <FormattedMessage
                        id="step2.descriptionDom"
                        defaultMessage="Avaliação comportamental e situacional de candidatos"
                      />
                    </Text>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div> */}

        <div className={separatorStyle}></div>

        <Space height="1rem" />

        {formState.fichasSelected.map((currentSelect, index) => (
          <div key={currentSelect.uid}>
            {index >= 1 ? <Space /> : null}
            <Label
              text={
                <FormattedMessage
                  id="step2.fichasTestes"
                  defaultMessage="Fichas e testes"
                />
              }
            ></Label>
            <div className={wrapperAdicionarRemoverFichas}>
              <Select
                aria-label="Fichas e testes"
                className={selectFichasStyle}
                placeholder={intl.formatMessage(
                  defineMessage({
                    id: "step1.placeholderFichasTestees",
                    defaultMessage: "Escolha uma ficha ou teste",
                  })
                )}
                value={currentSelect.fichaSelecionadaId}
                onChange={(e) => {
                  if (Number(e.target.value) === 0) {
                    setFormState((prev) => ({
                      fichasSelected: prev.fichasSelected.map((v) => {
                        if (v.uid === currentSelect.uid)
                          return {
                            ...v,
                            isPreenchimentoObrigatorio: false,
                          };

                        return v;
                      }),
                    }));
                  }
                  setFormState((prev) => ({
                    fichasSelected: prev.fichasSelected.map((v) => {
                      if (v.uid === currentSelect.uid)
                        return {
                          ...v,
                          fichaSelecionadaId: Number(e.target.value),
                        };
                      return v;
                    }),
                  }));
                }}
                data-testid="select-fichas"
              >
                {renderFichasSelectOptions(currentSelect.fichaSelecionadaId)}
              </Select>

              {index === formState.fichasSelected.length - 1 ? (
                <button
                  type="button"
                  className={btnAdicionarRemoverStyle}
                  disabled={
                    formState.fichasSelected.length >= 4 ||
                    !currentSelect.fichaSelecionadaId
                  }
                  onClick={() =>
                    setFormState((prev) => ({
                      fichasSelected: [
                        ...prev.fichasSelected,
                        {
                          uid: uid(),
                          fichaSelecionadaId: "",
                          isPreenchimentoObrigatorio: false,
                        },
                      ],
                    }))
                  }
                  aria-label="adicionar ficha"
                >
                  <IconPlusCircle />
                </button>
              ) : (
                <button
                  type="button"
                  className={btnAdicionarRemoverStyle}
                  disabled={formState.fichasSelected.length <= 1}
                  onClick={() =>
                    setFormState((prev) => ({
                      fichasSelected: prev.fichasSelected.filter(
                        (v) => v.uid !== currentSelect.uid
                      ),
                    }))
                  }
                  aria-label="remover ficha"
                >
                  <IconMinusCircle />
                </button>
              )}
            </div>

            {currentSelect.fichaSelecionadaId ? (
              <>
                <Space height=".5rem" />

                <Checkbox
                  label={
                    <FormattedMessage
                      id="step2.preenchimentoObrigatorio"
                      defaultMessage="Preenchimento obrigatório"
                    />
                  }
                  checked={currentSelect.isPreenchimentoObrigatorio}
                  onChange={(e) =>
                    setFormState((prev) => ({
                      fichasSelected: prev.fichasSelected.map((v) => {
                        if (v.uid === currentSelect.uid)
                          return {
                            ...v,
                            isPreenchimentoObrigatorio: e.target.checked,
                          };

                        return v;
                      }),
                    }))
                  }
                />
              </>
            ) : null}
          </div>
        ))}

        <Space height="1rem" />

        <div className={separatorStyle}></div>

        <Space height="1rem" />

        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text weight={600}>
            <FormattedMessage
              id="step2.integracoes"
              defaultMessage="Integrações"
            />{" "}
          </Text>
          <Text size="sm">
            <FormattedMessage
              id="step12.integracoesMarketPlace"
              defaultMessage="Confira todas as integrações disponíveis no nosso marketplace.
                Adicione recursos para melhorar seu processo seletivo. <a></a>"
              values={{
                a: (chunks) => (
                  <a
                    href={`${process.env.GLOBAL_URL}/marketplace`}
                    style={{
                      color: vars.color.brand,
                      textDecoration: "none",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {chunks}
                    <b>
                      <FormattedMessage
                        id="step2.acessarMarketPlace"
                        defaultMessage="Acessar o VAGAS Marketplace."
                      />
                    </b>
                  </a>
                ),
              }}
            />
          </Text>
        </div>
      </FormCard>

      <FormCard
        title={
          <FormattedMessage
            id="step2.titleComunicacaoCandidato"
            defaultMessage="Feedbacks automáticos"
          />
        }
        data-testid="bloco-email"
      >
        <Checkbox
          label={
            <FormattedMessage
              id="step2.titleEnviarMensagem"
              defaultMessage="Envie um e-mail para os candidatos após a inscrição"
            />
          }
          checked={formState.isEnviarEmail}
          onChange={(e) => {
            if (!e.target.checked) {
              setFormState({
                emailRemetente: "",
                emailMensagem: "",
                modeloEmailSelectedId: "",
                isExibirRemetente: false,
              });
            }
            setFormState({ isEnviarEmail: e.target.checked });
          }}
          data-testid="checkbox-enviar-mensagem"
        />

        {formState.isEnviarEmail ? (
          <>
            <Space />
            {formState.modelosEmailData?.length ? (
              <>
                <Select
                  label={
                    <FormattedMessage
                      id="step2.modeloMensagem"
                      defaultMessage="Modelos de mensagens"
                    />
                  }
                  value={formState.modeloEmailSelectedId}
                  onChange={(e) => {
                    const modeloEmailSelectedId = Number(e.target.value);
                    if (modeloEmailSelectedId) {
                      const mensagem = formState.modelosEmailData.find(
                        (v) => v.id === modeloEmailSelectedId
                      );
                      setFormState({
                        emailMensagem: mensagem.html,
                      });
                    }
                    if (modeloEmailSelectedId === 0) {
                      setFormState({ emailMensagem: "" });
                    }
                    setFormState({
                      modeloEmailSelectedId,
                    });
                  }}
                >
                  {renderSelectOptions({
                    data: formState.modelosEmailData,
                    error: formState.modelosEmailError,
                    errorMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.erro",
                        defaultMessage: "Ocorreu um erro",
                      })
                    ),
                    loadingMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.loading",
                        defaultMessage: "Carregando...",
                      })
                    ),
                    selectOptionMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.escolherOpcao",
                        defaultMessage: "Selecione uma opção...",
                      })
                    ),
                  })}
                </Select>

                <Space />
              </>
            ) : null}

            <TextEditor
              label={
                <FormattedMessage
                  id="step2.mensagem"
                  defaultMessage="Mensagem"
                />
              }
              value={formState.emailMensagem}
              onChange={(e) => setFormState({ emailMensagem: e })}
              isValid={formState.isEnviarEmail && emailMensagemTextLength}
              shouldValidate={hasTriedToSubmit}
              errorMessage={
                <FormattedMessage
                  id="erro.campoObrigatorio"
                  defaultMessage="Campo obrigatório"
                />
              }
              isImageHidden
              isVideoHidden
              length={emailMensagemTextLength}
            />

            <Checkbox
              label={
                <FormattedMessage
                  id="step2.exibirRemetente"
                  defaultMessage="Exibir meu e-mail para os profissionais"
                />
              }
              checked={formState.isExibirRemetente}
              onChange={(e) =>
                setFormState({ isExibirRemetente: e.target.checked })
              }
            />

            {formState.isExibirRemetente ? (
              <>
                <Space />
                <Label
                  text={
                    <FormattedMessage
                      id="step2.nomeRemetente"
                      defaultMessage="Nome remetente"
                    />
                  }
                >
                  <Input
                    type="nome"
                    value={formState.nomeRemetente}
                    onChange={(e) =>
                      setFormState({ nomeRemetente: e.target.value })
                    }
                    required={formState.isExibirRemetente}
                    shouldValidate={hasTriedToSubmit}
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                  />
                </Label>

                <Space />
                <Label
                  text={
                    <FormattedMessage
                      id="step2.emailRemetente"
                      defaultMessage="E-mail remetente"
                    />
                  }
                >
                  <Input
                    type="email"
                    value={formState.emailRemetente}
                    onChange={(e) =>
                      setFormState({ emailRemetente: e.target.value })
                    }
                    required={formState.isExibirRemetente}
                    shouldValidate={hasTriedToSubmit}
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                  />
                </Label>
              </>
            ) : null}
          </>
        ) : null}
      </FormCard>

      <FormCard
        title={
          <FormattedMessage
            id="step2.titleIndicacao"
            defaultMessage="Indicação de profissionais"
            description="Está relacionado a indicar alguém para ocupar um cargo"
          />
        }
        description={
          <FormattedMessage
            id="step2.descriptionIdicacao"
            defaultMessage="As indicações ficarão atreladas aos currículos dos candidatos e poderão ser encontradas na 
            triagem da vaga."
          />
        }
        data-testid="bloco-indicacao"
      >
        <Checkbox
          label={
            <FormattedMessage
              id="step2.aceitarIdicacao"
              defaultMessage="Aceitar indicações"
            />
          }
          checked={formState.isIndicacaoSelecionada}
          onChange={(e) =>
            setFormState({ isIndicacaoSelecionada: e.target.checked })
          }
          data-testid="checkbox-indicacoes"
        />

        {formState.isIndicacaoSelecionada ? (
          <>
            <Space height=".5rem" />

            <Fieldset
              isValid={!formState.isIndicacaoSelecionada}
              shouldValidate={hasTriedToSubmit}
              errorMessage={
                <FormattedMessage
                  id="erro.campoObrigatorio"
                  defaultMessage="Campo obrigatório"
                />
              }
            >
              <RadioButton
                label={
                  <FormattedMessage
                    id="step2.indicacaoQualquerPessoa"
                    defaultMessage="De qualquer pessoa/e-mail"
                    description="O contexto da frase é: Aceita indicações de qualquer pessoa"
                  />
                }
                name="tipo-indicacao"
                value="indicacao-livre"
                checked={formState.tipoIndicacao === "indicacao-livre"}
                onChange={(e) =>
                  setFormState({ tipoIndicacao: e.target.value })
                }
                data-testid="indicacao-livre"
                required
              />
              <RadioButton
                label={
                  <FormattedMessage
                    id="step2.indicacaoRestricao"
                    defaultMessage="Somente de e-mails ou domínios abaixo:"
                    description="O contexto da frase é: Aceita indicações somente com restrição de e-mails ou domínios"
                  />
                }
                name="tipo-indicacao"
                value="indicacao-restrita"
                checked={formState.tipoIndicacao === "indicacao-restrita"}
                onChange={(e) =>
                  setFormState({ tipoIndicacao: e.target.value })
                }
                data-testid="indicacao-restrita"
              />
            </Fieldset>
            {formState.tipoIndicacao === "indicacao-restrita" ? (
              <>
                {renderEmailsIndicacao()}
                <Space />
                <Button
                  className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                  onClick={() => handleEmailsIndicacaoSubmit()}
                  data-testid="btn-salvar-apresentacao"
                  disabled={
                    isPostPending ||
                    formState.emailsIndicacaoData ===
                      formState.emailsIndicacao ||
                    !formState.emailsIndicacao.length
                  }
                >
                  {isPostPending ? (
                    <Spinner colorVariant="light" />
                  ) : (
                    <FormattedMessage
                      id="botao.salvar"
                      defaultMessage="Salvar"
                    />
                  )}
                </Button>
                <Toaster toasts={toasts} />
              </>
            ) : null}
          </>
        ) : null}
      </FormCard>

      <div className={formButtonsWrapper}>
        <Button
          className={`${secondaryButton} ${inputVariants["form-buttons"]}`}
          type="button"
          data-testid="btn-voltar"
          onClick={() => setSelectedStepId(1)}
          id="continuar-para-step3"
        >
          <FormattedMessage id="botao.voltar" defaultMessage="Voltar" />
        </Button>
        <Space />
        <Button
          className={`${primaryButton} ${inputVariants["form-buttons"]}`}
          type="submit"
          onClick={() => setHasTriedToSubmit(true)}
          data-testid="btn-continuar"
          disabled={
            (!formState.fasesSelected?.length && !isVagaModelo) ||
            (formState.isEnviarEmail && !emailMensagemTextLength)
          }
        >
          <FormattedMessage id="botao.continuar" defaultMessage="Continuar" />
        </Button>
      </div>
    </form>
  );
}
